import { FiHome, FiUsers, FiUserPlus, FiBell, FiMail } from "react-icons/fi";
import { RiUserSearchLine } from "react-icons/ri";
import { LiaUserClockSolid } from "react-icons/lia";

export const menuRoutes = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: <FiHome />,
    matchNested: true,
    relatedPaths: ["/analytics", "/daily-data-table"],
  },
  {
    label: "Customer",
    path: "/customer",
    icon: <FiUsers />,
    matchNested: true,
  },
  {
    label: "All Leads",
    path: "/dashboard/leads",
    icon: <RiUserSearchLine />,
    matchNested: true,
  },
  {
    label: "Add User",
    path: "/add-user",
    icon: <FiUserPlus />,
    matchNested: true,
  },
  {
    label: "User Activity",
    path: "/activity",
    icon: <LiaUserClockSolid />,
    matchNested: true,
  },
  {
    label: "Notifications",
    path: "/notifications",
    icon: <FiBell />,
    matchNested: true,
  },
  {
    label: "Send Email",
    path: "/send-email",
    icon: <FiMail />,
    matchNested: true,
  },
];
